import React from 'react';
import {
    VehicleCardContainer,
    VehicleImageContainer,
    VehicleImage,
    HeaderRow,
    StockNumberTypography,
    DealOptionsRow,
    DealOption,
    DealOptionRadio,
    // DealOptionCheckbox,
    DealOptionInfo,
    DealOptionDate,
    DealOptionLabel
} from './VehicleCard.style';
import type { GroupedDeal } from '../../types';
import { formatDateTime, formatVehicleName } from '../../utils/utils';
import blankVehicle from '../../assets/blankVehicle.svg';
import { ResponsiveHeading } from '@makemydeal/dr-sales-checkin-components/responsive-heading';

export type SelectedDeal = { dealId: string; version: string } | null;

export const VehicleCard: React.FC<
    GroupedDeal & {
        selectedDeal?: SelectedDeal;
        onSelectDeal?: (dealId: string, version: string) => void;
        // ---- compare workflow ----
        // showCheckboxes?: boolean;
        // selectedVersions?: Set<string>;
        // isMaxSelected?: boolean;
        // onSelectionChange?: (version: string, checked: boolean) => void;
        // showOpenDealCTA?: boolean;
    }
> = ({ dealId, sellingVehicle, deals, selectedDeal, onSelectDeal }) => {
    const vehicleName = formatVehicleName(sellingVehicle);
    const stockNumber = sellingVehicle?.stockNumber || 'N/A';
    const vehicleImage = sellingVehicle?.vehicleImage || null;

    const dealOptions = [...deals]
        .sort((a, b) => new Date(b.versionCreatedOn).getTime() - new Date(a.versionCreatedOn).getTime())
        .map((deal) => ({
            type: deal.dealType,
            date: formatDateTime(deal.versionCreatedOn),
            version: deal.version
        }));

    const isSelected = (version: string) =>
        selectedDeal != null && selectedDeal.dealId === dealId && selectedDeal.version === version;

    // ---- compare workflow ----
    // const isSelected = (version: string) => selectedVersions?.has(version) ?? false;

    return (
        <VehicleCardContainer data-testid={`vehicle-card-${stockNumber}`}>
            <VehicleImageContainer>
                <VehicleImage src={vehicleImage ?? blankVehicle} alt={vehicleName} data-testid={`vehicle-image-${stockNumber}`} />
            </VehicleImageContainer>

            <HeaderRow>
                <ResponsiveHeading level={5} weight="semibold" data-testid="vehicle-name">
                    {vehicleName}
                </ResponsiveHeading>
                <StockNumberTypography level={7} weight="regular" data-testid="stock-number">
                    Stock# {stockNumber}
                </StockNumberTypography>
            </HeaderRow>

            <DealOptionsRow>
                {dealOptions.map((dealOption) => {
                    const typeKey = dealOption.type.toLowerCase();
                    return (
                        <DealOption
                            key={`${dealOption.type}-${dealOption.version}`}
                            data-testid={`deal-option-${stockNumber}-${typeKey}`}
                        >
                            <DealOptionRadio
                                name="deal-list-selection"
                                checked={isSelected(dealOption.version)}
                                onChange={() => onSelectDeal?.(dealId, dealOption.version)}
                                data-testid={`radio-${typeKey}`}
                                aria-label={`${dealOption.type} deal`}
                            />
                            {/* ---- compare workflow ----
                            {showCheckboxes && (
                                <DealOptionCheckbox
                                    checked={isSelected(dealOption.version)}
                                    disabled={isMaxSelected && !isSelected(dealOption.version)}
                                    onChange={(e) => onSelectionChange?.(dealOption.version, e.target.checked)}
                                    data-testid={`checkbox-${typeKey}`}
                                    aria-label={`${dealOption.type} deal`}
                                />
                            )} */}
                            <DealOptionInfo>
                                <DealOptionLabel size="small" weight="semibold" data-testid={`deal-type-${typeKey}`}>
                                    {dealOption.type}
                                </DealOptionLabel>
                                <DealOptionDate size="small" data-testid={`deal-date-${typeKey}`}>
                                    {dealOption.date}
                                </DealOptionDate>
                            </DealOptionInfo>
                        </DealOption>
                    );
                })}
            </DealOptionsRow>
        </VehicleCardContainer>
    );
};

export default VehicleCard;
